import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Card,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Link from "@mui/material/Link";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import React, { useEffect, useRef, useState } from "react";
import Countdown from "react-countdown";
import OtpInput from "react-otp-input";
import KenButton from "./GlobalComponents/KenButton";
import { SendOTP, VerifyLeadOTP } from "./Utils/apiServices";
import KenLoader from "./GlobalComponents/KenLoader";
// import { LOGO, PUBLIC_BACKGROUND_IMAGE_URL } from "../../../Helpers/constants";

const useStyles = makeStyles((theme) => ({
  formLayout: {
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
    height: "100%",
  },
  otpHeader: {
    display: "flex",
    position: "relative",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  backIcon: {
    height: "26px",
    width: "auto",
    color: "#000000",
  },
  resend: {
    border: "none",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#07588f",
    cursor: "pointer",
    fontStyle: '"Red Hat Text", sans-serif !important',
    marginTop: "20px !important",
  },
  otpContainerCard: {
    padding: "40px 50px",

    borderRadius: "20px !important",
    marginTop: "20px",
    height: "maxContent",
  },

  footerSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginTop: "60px",
  },
  otpContainerStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  otpInputStyle: {
    border: "1px solid #E0E0E0",
    borderRadius: "8px",
    width: "48px !important",
    height: "64px",
    fontSize: "16px",
    margin: "0 8px",
    textAlign: "center",
    justifyContent: "center",
  },
  backButton: {
    color: "#000000",
    fontWeight: "400",
    fontSize: "14px",
    cursor: "pointer",
    textDecoration: "underline",
  },
}));

function pad(n, width, z) {
  z = z || "0";
  n = n + "";
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}
const VerifyOTP = ({ handleBackClick, email, data }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [loader, setLoader] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [otp, setOtp] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [responseData, setResponseData] = useState();
  const [seconds, setSeconds] = useState(5);
  const [timerRunning, setTimerRunning] = useState(false);

  console.log(responseData);

  useEffect(() => {
    let timer;

    if (timerRunning && seconds > 0) {
      timer = setTimeout(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    }

    return () => clearTimeout(timer);
  }, [timerRunning, seconds]);

  const handleStartTimer = () => {
    setSeconds(5); // Reset the timer to 5 seconds
    setTimerRunning(true); // Start the timer
  };

  useEffect(() => {
    if (seconds === 0) {
      // Redirect when the timer ends
      alert("Redirected to the Application Page.");
      window.open(
        `https://aims-application-dev.ken42.com/login?AIMS_Level_of_Study__c=${
          responseData?.account?.AIMS_Level_of_Study__c
        }&Name=${
          responseData?.account?.FirstName + " " + responseData?.account?.LastName
        }&ContactId=${responseData?.account?.Id}&Email=${
          responseData?.account?.PersonEmail
        }&Phone=${responseData?.account?.PersonMobilePhone}&access_token=${responseData?.accessToken?.token}`,
        "_self"
      );
    }
  }, [seconds]);

  let COOL_DOWN_COUNT_IN_SECONDS = 2 * 60;
  const countDownRef = useRef();
  const [countDown, setCountDown] = useState(
    Date.now() + COOL_DOWN_COUNT_IN_SECONDS * 1000
  );

  const mobileScreen = useMediaQuery(theme.breakpoints.up("sm"));

  const otpChange = (value) => {
    setOtp(value);
  };

  const resendOtp = async (data) => {
    try {
      setLoader(true);
      const res = await SendOTP(email, data);
      if (res?.success) {
        setLoader(false);
        setCountDown(Date.now() + COOL_DOWN_COUNT_IN_SECONDS * 1000);
        countDownRef.current.api.start();
      } else {
        enqueueSnackbar(res.message, {
          variant: "error",
        });
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setLoader(false);
      enqueueSnackbar("Something went wrong while sending OTP", {
        variant: "error",
      });
    }
  };

  const handleVerifyClick = async (event) => {
    try {
      event.preventDefault(); // Prevent default form submission behavior

      // Call VerifyLeadOTP API with email and otp
      setLoader(true);

      console.log(otp=='', "otp");
      if (otp == '') {
        setLoader(false);
        enqueueSnackbar("Please enter OTP", {
          variant: "error",
        });
      } else {
        const res = await VerifyLeadOTP({
          email: email,
          otp: otp,
          type: "Lead",
          leadId: data?.leadId,
        });

        console.log(res, "sdsfsf")
      const isSeparateFormat = res.hasOwnProperty('0');
      console.log(isSeparateFormat, "isSeparateFormat")

      if(isSeparateFormat) {
        const properResponse = res;

        const responseData = {
          "userName": properResponse.userName,
          "userId": properResponse.userID,
          "userEmail": properResponse.userEmail,
          "userDob": properResponse.userDob,
          "success": false,
          "OTP": properResponse.OTP,
          "levelOfStudy": "",
          "errorMessages": "Invalid OTP"
        };

        enqueueSnackbar(responseData.errorMessages, {
          variant: "error"
        })
        setLoader(false);
      } else {
        if (!res || !res?.success) {
          return enqueueSnackbar(res?.errorMessage || 'Something went wrong', {
            variant: 'error',
          });
        }

        if (res?.success) {
          setLoader(false);
          setResponseData(res);
          setShowSuccessMessage(true);
          handleStartTimer();
        } else {
          // Handle error response
          setLoader(false);
          enqueueSnackbar(res.errorMessage || "Failed to verify OTP", {
            variant: "error",
          });
        }
      }
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setLoader(false);
      enqueueSnackbar(error?.response?.data?.result?.errorMessage || "Something went wrong while verifying OTP", {
        variant: "error",
      });
    }
  };

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return (
        <Typography className={classes.resend}>
          <span style={{ color: "black" }}>Did not receive it yet? </span>
          <span
            onClick={() => {
              resendOtp(data);
              countDownRef.current.api.start();
            }}
          >
            <b>
              <u>Resend it</u>
            </b>
          </span>
        </Typography>
      );
    } else {
      return (
        <Typography
          color={"#07588f"}
          fontWeight={"bold"}
          fontSize={"14px"}
          margin={"10px auto"}
        >
          {pad(`${minutes}`, 2)}:{pad(`${seconds}`, 2)}
        </Typography>
      );
    }
  };

  useEffect(() => {
    if (countDownRef) {
      countDownRef.current.api.start();
    }
  }, [countDown]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
    };
    // window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      {loader && <KenLoader />}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh", // Set the height to 100% of the viewport height
        }}
      >
        <Grid
          component={"div"}
          className="bg-white h-100 mx-auto"
          maxWidth={"360px"}
        >
          {showSuccessMessage ? (
            <>
              {timerRunning && (
                <Typography style={{ fontSize: "14px" }}>
                  Redirecting to Admission Portal in {seconds}
                </Typography>
              )}
              <Typography style={{ fontSize: "14px" }}>
                Thank you for your interest in AIMS Institute! Our admission
                team will contact you shortly. Stay tuned for a call on your
                registered phone number. To proceed to the application form,
                kindly click on the following link:
              </Typography>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <Link
                  style={{ marginTop: "6px" }}
                  href="https://aims-application-dev.ken42.com/
                  "
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Click here
                </Link>
                <Typography
                  style={{
                    fontSize: "14px",
                    marginTop: "10px",
                    marginLeft: "5px",
                  }}
                >
                  Additionally, feel free to visit our
                  <Link
                    style={{
                      marginTop: "6px",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                    href="https://www.theaims.ac.in/
                  "
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Website
                  </Link>
                  for more information.We look forward to assisting you further
                  on your academic journey!
                </Typography>
              </div>
            </>
          ) : (
            <form onSubmit={handleVerifyClick}>
              <div
                className={classes.formLayout}
                style={{ width: "100%", justifyContent: "center" }}
              >
                <div className={classes.otpHeader}>
                  <IconButton
                    style={{ position: "absolute", left: "0" }}
                    onClick={handleBackClick}
                  >
                    <ArrowBackIcon className={classes.backIcon} />
                  </IconButton>
                  {/* <img src={LOGO} alt="Logo" height={50} width={30} /> */}
                </div>
                <p className={classes.resend}>
                  <span style={{ color: "black" }}>An OTP has been sent to</span>{" "}
                  {email}
                </p>
                <Card className={classes.otpContainerCard}>
                  <OtpInput
                    numInputs={4}
                    value={otp}
                    onChange={(otpValue) => otpChange(otpValue)}
                    renderInput={(inputProps, index) => (
                      <input {...inputProps} key={index} type="tel" />
                    )}
                    containerStyle={classes.otpContainerStyle}
                    inputStyle={classes.otpInputStyle}
                  />
                </Card>
                <center>
                  <Countdown
                    ref={countDownRef}
                    date={countDown}
                    renderer={renderer}
                  />
                </center>
                <Box component={"div"} className={classes.footerSection}>
                  <KenButton
                    type='submit'
                    variant="primary"
                    // onClick={handleVerifyClick}
                    style={{ margin: "25px", color: "white !important" }}
                  >
                    Submit
                  </KenButton>
                </Box>
              </div>
            </form>
          )}
        </Grid>
      </div>
    </>
  );
};

export default VerifyOTP;
